import { getServerDataWithTokenV2 } from "../helper/helper"

export const fetchExams = async (token) => {
    try {
        const examType = await getServerDataWithTokenV2(`${process.env.REACT_APP_SERVER_HOSTNAME}/api/examTypes`, token, (data) => data)
        return examType
    } catch(error){
        console.log(error)
    }
}